export default "__VITE_ASSET__c41d45cd__"